import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import WhyUs from "@/components/site/WhyUs";
import ResultsThatMatter from "@/components/site/ResultsThatMatter";
import Services from "@/components/site/Services";
import AssessmentForm from "@/components/site/AssessmentForm";
import Origin from "@/components/site/Origin";
import Programs from "@/components/site/Programs";
import Camps from "@/components/site/Camps";
import TrainAnywhere from "@/components/site/TrainAnywhere";
import TrainingOptions from "@/components/site/TrainingOptions";
import Pathways from "@/components/site/Pathways";
import Shop from "@/components/site/Shop";
import Waitlist from "@/components/site/Waitlist";
import Coach from "@/components/site/Coach";
import Testimonials from "@/components/site/Testimonials";
import TrustedAffiliated from "@/components/site/TrustedAffiliated";
import Locations from "@/components/site/Locations";
import RequiredForms from "@/components/site/RequiredForms";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <div className="bg-black text-white overflow-x-hidden" data-testid="home-page">
      <Nav />
      <main>
        <Hero />
        <WhyUs />
        <ResultsThatMatter />
        <Coach />
        <Services />
        <AssessmentForm />
        <Origin />
        <Programs />
        <Camps />
        <TrainAnywhere />
        <TrainingOptions />
        <Pathways />
        <Shop />
        <Testimonials />
        <TrustedAffiliated />
        <Locations />
        <RequiredForms />
        <FAQ />
        <Contact />
        <Waitlist />
        <ResultsThatMatter compact />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
